'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineCircuitBreakerDecorator;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _errors = require('../errors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineCircuitBreakerDecorator(_ref) {
  var _ref$callLimit = _ref.callLimit,
      callLimit = _ref$callLimit === undefined ? 5 : _ref$callLimit,
      _ref$callTimeoutInMs = _ref.callTimeoutInMs,
      callTimeoutInMs = _ref$callTimeoutInMs === undefined ? 1000 : _ref$callTimeoutInMs;

  var callTimestamps = [];
  var isOpen = false;

  return function circuitBreakerDecorator(resolver) {
    return function () {
      var now = Date.now();

      var oldestTimestamp = 0;

      if (callTimestamps.length === callLimit) {
        oldestTimestamp = callTimestamps.pop();
      }

      var callLimitExceeded = now - oldestTimestamp < callTimeoutInMs;

      if (isOpen || callLimitExceeded) {
        isOpen = true;
        return _q2.default.reject(new _errors.CircuitBreakerError());
      }

      callTimestamps.unshift(now);
      return resolver.apply(undefined, arguments);
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/decorators/defineCircuitBreakerDecorator.js
// module id = 455
// module chunks = 0